<template>
  <div class="form-group">
    <div class="input-group">
       <textarea :id="id"
                 :name="name"
                 :disabled="disabled"
                 v-model="text"
                 :placeholder="placeholder"
                 required
                 rows="2"
       ></textarea>
      <label class="control-label" :for="id">
        <slot name="label">{{ label }}</slot>
      </label>
      <i class="bar"></i>
    </div>
  </div>
</template>

<script>
  function generateRandomId () {
    return Math.floor(Math.random() * Math.pow(10, 10));
  }

  export default {
    name: 'vuestic-key-value',
    props: {
      label: String,
      id: {
        type: String,
        default () {
          // We require unique id to show label
          return 'label-' + generateRandomId();
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: '',
      },
      value: {},
      placeholder: {
        type: String,
        default () {
          return this.$t('Key: Value (one per line)');
        },
      },
    },
    data () {
      return {
        text: '',
        emitting: false,
      };
    },
    watch: {
      text () {
        let obj = this.text.split('\n').reduce((acc, x) => {
          let p = x.split(':', 2);
          let k = p[0].trim();
          if (k !== '' && p[1] && p[1].length) {
            acc[k] = p[1].trim();
          }
          return acc;
        }, {});
        this.emitting = true;
        this.$emit('input', obj);
        this.$nextTick(() => {
          this.emitting = false;
        });
      },
      value: {
        immediate: true,
        handler (v) {
          if (!this.emitting) {
            this.text = Object.entries(v || {}).map(x => x[0] + ': ' + x[1]).join('\n');
          }
        },
      },
    },
  };
</script>

<style scoped>
  textarea {
    resize      : vertical !important;
    min-height  : 2.4em;
    line-height : 1.2em;
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-key-value/VuesticKeyValue.vue